
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Database } from "@/integrations/supabase/types";

type Reading = Database["public"]["Tables"]["readings"]["Row"];

export const useReadings = (houseId: string | null, type: "water" | "electricity") => {
  return useQuery({
    queryKey: ["readings", houseId, type],
    queryFn: async () => {
      if (!houseId) return [];

      const { data, error } = await supabase
        .from("readings")
        .select("*")
        .eq("house_id", houseId)
        .eq("type", type)
        .order("reading_date", { ascending: false });

      if (error) throw error;

      return data || [];
    },
    enabled: !!houseId,
  });
};
